/**
 * Escape special characters in the URI function escapes [']
 * @param str URI string to be escaped
 * @return Escaped URI string
 * @deprecated
 * @see `@netx/core-next/utils/string/enhancedEncodeURIComponent`
 */
export const escapeURI = (str: string) => {
	return encodeURIComponent(str).replace("'", '%27');
};

export default escapeURI;
